import { makeAutoObservable } from 'mobx';
import type { BibleLocation } from '@skjv/common';

/** Strong's definition display data */
export interface StrongsDisplay {
  numbers: string;
  location: BibleLocation;
  isVisible: boolean;
  englishWord?: string;
  websterDefinition?: string;
}

/**
 * Strong's panel display state.
 */
export class StrongsState {
  /** Currently displayed Strong's definition */
  strongsDisplay: StrongsDisplay | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  /** Show Strong's definition panel */
  showStrongsDefinition(
    numbers: string,
    location: BibleLocation,
    opts?: { englishWord?: string; websterDefinition?: string },
  ): void {
    this.strongsDisplay = {
      numbers,
      location,
      isVisible: true,
      englishWord: opts?.englishWord,
      websterDefinition: opts?.websterDefinition,
    };
  }

  /** Hide Strong's definition panel */
  hideStrongsDefinition(): void {
    if (this.strongsDisplay) {
      this.strongsDisplay.isVisible = false;
    }
  }
}
